export default function safeExecute<T, DV = T>(mapFunction: () => T, defaultValue: DV | null = null): T | DV | null {
  try {
    return mapFunction();
    // eslint-disable-next-line no-empty
  } catch (e) {}

  return defaultValue;
}
